@if (isInboxElementVisible(commonDataService.customerSettings?.inboxElementsVisibility?.leftPanel?.communitySelector)) {
    <app-community-switcher data-testid="inbox-ui-left-sidebar-community-selector"></app-community-switcher>
}

@if (
    !commonDataService.user.isReadOnly &&
    isInboxElementVisible(commonDataService.customerSettings?.inboxElementsVisibility?.leftPanel?.createTicket)
) {
    <button
        type="button"
        class="btn btn-block d-flex align-items-center justify-content-center"
        data-testid="inbox-ui-left-sidebar-create-new-ticket"
        (click)="openNewTicketModal()">
        <sb-inline-svg
            class="icon icon-sm me-2"
            aria-label="My icon"
            [url]="'/sb-tools/theme/images/Svg icons WEB/Web icons/Outlined plus icon.svg'"></sb-inline-svg>
        <span>
            {{ 'Create a new ticket' | translate }}
        </span>
    </button>
}

@if (
    commonDataService.customerSettings.isBotEnabled &&
    isInboxElementVisible(commonDataService.customerSettings?.inboxElementsVisibility?.leftPanel?.botTicketsView)
) {
    <div class="list-group" data-testid="inbox-ui-left-sidebar-bot-tickets-view">
        <a
            class="left-menu-link"
            [routerLink]="['/', communityName, 'tickets']"
            [queryParams]="{ isAssignedToBot: true, status: ticketStatusEnum.open }"
            routerLinkActive="active">
            <div
                (click)="checkLinkClick($event)"
                class="link-content-wrapper list-group-item list-group-item-action d-flex justify-content-between align-items-center">
                <span>
                    <sb-inline-svg
                        class="icon vertical-align-middle"
                        aria-label="My icon"
                        style="position: relative; bottom: 1px"
                        [url]="'/sb-tools/theme/images/Svg icons WEB/Web icons/Bot icon.svg'"></sb-inline-svg>
                    <span class="vertical-align-middle" translate>Bot tickets</span>
                </span>
                @if (getCount(['botTickets', 'open'])) {
                    <span [ngClass]="{ 'badge-dangerous': isBotTicketsWithOpen }" class="badge">{{
                        getCount(['botTickets', 'open'])
                    }}</span>
                }
            </div>
        </a>
    </div>
}

@for (item of leftMenuBaseItems; track item) {
    <app-left-menu-item
        [attr.data-testid]="item.visibilityTestId"
        [item]="item"
        [countUpdateMarker]="countUpdateMarker">
    </app-left-menu-item>
}

@if (
    !commonDataService.user.isReadOnly &&
    isInboxElementVisible(commonDataService.customerSettings?.inboxElementsVisibility?.leftPanel?.filters) &&
    leftMenuFiltersItems?.length
) {
    <div data-testid="inbox-ui-left-sidebar-filters">
        @for (item of leftMenuFiltersItems; track item) {
            <app-left-menu-item [item]="item" [countUpdateMarker]="countUpdateMarker"> </app-left-menu-item>
        }
    </div>
}
